import React from "react";
import "./card.css";

const TeamProfile = ({ teammates }) => {
  return (
    <div className="scholars">
      <div className="scholar-field">{teammates[0].degree}</div>
      <div className="scholar-info">
        {teammates.slice(1).map((teammate, index) => (
          <div key={index} className="scholar">
            <div
              className="scholar-img"
              style={{ backgroundImage: `url(${teammate.image})` }}
            ></div>
            <div className="scholar-name">{teammate.name}</div>
            <p className="topic">{teammate.topic}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamProfile;
